import styled from "styled-components";

export const BonusAndCashBalanceDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    ${({theme}) => theme.font.presets.body}
    font-size: 1.4rem;
    padding: 1rem 0 1rem;
`;

